import React, {useState} from 'react';
import Ruby from '../images/ruby.png';
import Javascript from '../images/javascript.png';
import Postgres from '../images/postgresql.png';
import CPP from '../images/cpp.png';
import HTML from '../images/html.png';
import CSS from '../images/css.png';
import ReactJS from '../images/react.png';
import Rails from '../images/rails.png';
import Express from '../images/express.png';
import VSCode from '../images/vscode.png';
import Photoshop from '../images/photoshop.png';
import Trello from '../images/trello.png';
import FCP from '../images/fcp.png';
import AWS from '../images/aws.png';
import Node from '../images/nodejs.png'

export default function Skills() {

    const [skillWidth,setSkillWidth] = useState(()=>getWidth());
    const [skillDirection, setSkillDirection] = useState(()=>getDirection());


    const style = {
        aboutdiv: {
            margin: "0 auto",
            width: "75%",
            border: "1px solid black",
            borderRadius: "5px",
            backgroundColor: "white",
            padding: "20px",
            textAlign: "center"
        },
        overall: {
            backgroundColor: "#0b486b",
            height: "auto",
            minHeight: "80vh",
            padding: "50px 0"
        },
        list: {
            padding: "0"
        },
        listitem: {
            listStyle: "none",
            margin: "0",
            padding: "0"
        },
        expdiv: {
            width: skillWidth
        },
        maindiv: {
            display: "flex",
            flexDirection: skillDirection,
            margin: "0 auto",
            padding: "20px"
        },
        sectiontitle: {
            margin: "0",
            fontSize: "20px",
            fontWeight: "bold"
        },
        title: {
            fontSize: "32px",
            margin: "4px"
        },
        itemdiv: {
            display: "inline-block",
            width: "80px",
            marginTop: "5px"
        },
        itemp: {
            margin: "0"
        },
        sectioncontainer: {
            margin: "10px"
        }
    }

    function getWidth(){
        return window.innerWidth<800? "100%":"50%";
    }

    function getDirection(){
        return window.innerWidth<800? "column":"row";
    }

    function windowSize (){
        if (window.innerWidth<800){
            setSkillWidth("100%");
            setSkillDirection("column")
        } else {
            setSkillWidth("50%");
            setSkillDirection("row")
        }
    }

    window.addEventListener('resize', windowSize)

    return (
        <div style={style.overall}>
            <div style={style.aboutdiv}>
                <h2 style={style.title}>Skills</h2>
                <div style={style.maindiv}>
                    <div style={style.expdiv}>
                        <div style={style.list}>
                            <p style={style.sectiontitle}>Languages:</p>
                            <div style={style.sectioncontainer}>
                                <div style={style.itemdiv}>
                                    <img src={Ruby} alt="Ruby" title="Ruby" />
                                    <p style={style.itemp}>Ruby</p>
                                </div>
                                <div style={style.itemdiv}>
                                    <img src={Javascript} alt="Javascript" title="Javascript"/>
                                    <p style={style.itemp}>Javascript</p>
                                </div>
                                <div style={style.itemdiv}>
                                    <img src={CPP} alt="C++" title="C++"/>
                                    <p style={style.itemp}>C++</p>
                                </div>
                                <div style={style.itemdiv}>
                                    <img src={Postgres} alt="PostgresQL" title="PostgresQL"/>
                                    <p style={style.itemp}>PostgresQL</p>
                                </div>
                                <div style={style.itemdiv}>
                                    <img src={HTML} alt="HTML" title="HTML"/>
                                    <p style={style.itemp}>HTML</p>
                                </div>
                                <div style={style.itemdiv}>
                                    <img src={CSS} alt="CSS" title="CSS"/>
                                    <p style={style.itemp}>CSS</p>
                                </div>
                            </div>
                        </div>
                        <div style={style.list}>
                            <p style={style.sectiontitle}>Frameworks/Libraries:</p>
                            <div style={style.sectioncontainer}>
                                <div style={style.itemdiv}>
                                    <img src={ReactJS} alt="ReactJS" title="ReactJS"/>
                                    <p style={style.itemp}>ReactJS</p>
                                </div>
                                <div style={style.itemdiv}>
                                    <img src={Rails} alt="Ruby on Rails" title="Ruby on Rails" />
                                    <p style={style.itemp}>Rails</p>
                                </div>
                                <div style={style.itemdiv}>
                                    <img src={Express} alt="ExpressJS" title="ExpressJS"/>
                                    <p style={style.itemp}>Express</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={style.expdiv}>
                        <div style={style.list}>
                            <p style={style.sectiontitle}>Software:</p>
                            <div style={style.sectioncontainer}>
                                <div style={style.itemdiv}>
                                    <img src={VSCode} alt="Visual Studio Code" title="Visual Studio Code"/>
                                    <p style={style.itemp}>VS Code</p>
                                </div>
                                <div style={style.itemdiv}>
                                    <img src={Photoshop} alt="Adobe Photoshop" title="Adobe Photoshop"/>
                                    <p style={style.itemp}>Photoshop</p>
                                </div>
                                <div style={style.itemdiv}>
                                    <img src={Trello} alt="Trello" title="Trello"/>
                                    <p style={style.itemp}>Trello</p>
                                </div>
                                <div style={style.itemdiv}>
                                    <img src={FCP} alt="Final Cut Pro" title="Final Cut Pro"/>
                                    <p style={style.itemp}>FCP X</p>
                                </div>
                            </div>
                        </div>
                        <div style={style.list}>
                            <p style={style.sectiontitle}>Other:</p>
                            <div style={style.sectioncontainer}>
                                <div style={style.itemdiv}>
                                    <img src={Node} alt="NodeJS" title="NodeJS"/>
                                    <p style={style.itemp}>NodeJS</p>
                                </div>
                                <div style={style.itemdiv}>
                                    <img src={AWS} alt="Amazon Web Services" title="Amazon Web Services"/>
                                    <p style={style.itemp}>AWS</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}